<template>
    <div class="page">
        <div class="header">
            <Header :current="['data']"></Header>
        </div>
        <div class="iframe-content">
            <iframe id="indexIframe" width="100%" scrolling="no" frameborder="0" allowtransparency="true"></iframe>
        </div>
<!--        <div class="footer" id="footerTop">-->
<!--            <Footer></Footer>-->
<!--        </div>-->
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
// import Footer from "@/components/portal/Footer"
import {useRoute} from "vue-router"
export default {
    name: "otherData",
    setup() {
        const route = useRoute()
        return {
            route
        }
    },
    mounted() {
        this.setIframeUrl()
    },
    methods: {
        setIframeUrl() {
            document.getElementById('indexIframe').src = this.route.query.params
            document.getElementById('indexIframe').style.height = this.route.query.height + 'px'
            // document.getElementById('footerTop').style.top = (parseInt(this.route.query.height) - 151) + 'px'
        }
    },
    watch: {
        'route.query': (val) => {
            document.getElementById('indexIframe').src = val.params
            document.getElementById('indexIframe').style.height = val.height + 'px'
            // document.getElementById('footerTop').style.top = (parseInt(val.height) - 151) + 'px'
        }
    },
    components: {
        Header,
        // Footer
    }
}
</script>

<style scoped lang="stylus">
.page {
    width 100%
    height 100%
    position relative
    font-size 16px
    background-color #FFF
    .header {
        width 100%
        padding-top 130px
        box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
        background-color #388cda
        background-image url("../../assets/img/portal_home_bg.png")
        background-size 100% 100%
        background-repeat no-repeat
        padding-bottom 50px
        position relative
        z-index 1
    }
    .footer {
        width 100%
        position absolute
        left 0
        z-index 9999
    }
    .iframe-content {
        width 100%
        height 100%
        padding-top 80px
        position absolute
        left 0
        top 0
    }
}
</style>